import { Metric } from "../models/Metric";
import client from "./axios";

const metricsUrl = `${window.__env.CORE_URL}/metric-types`;

export const Metrics = {
  getMetrics: () => client.get<Metric[]>(metricsUrl),
  getMetric: (id: string) => client.get<Metric>(`${metricsUrl}/${id}`),
  createMetric: (metric: Metric) => client.post<Metric>(metricsUrl, metric),
  updateMetric: (metric: Metric) => client.put<Metric>(`${metricsUrl}/${metric.id}`, metric),
  deleteMetric: (id: Number) => client.delete<Metric>(`${metricsUrl}/${id}`),
}